export const referralProgramTableColumn = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: 60,
  },
  {
    title: "Referido por",
    dataIndex: "full_name",
    key: "full_name",
    width: 200,
    ellipsis: true,
  },
  {
    title: "Empresa referida",
    dataIndex: "company",
    key: "company",
    width: 220,
    ellipsis: true,
  },
  {
    title: "Cod Referido",
    dataIndex: "code",
    key: "code",
    width: 140,
  },
  {
    title: "Fecha y hora de creación",
    dataIndex: "created_at",
    key: "created_at",
    width: 190,
  },
  {
    title: "Detalle",
    dataIndex: "detail",
    key: "detail",
    slots: { customRender: "detail_scoped" },
    width: 140,
  },
  {
    title: "Estado del referido",
    dataIndex: "state",
    key: "state",
    width: 160,
    slots: { customRender: "state" },
  },
  {
    title: "Giftcard",
    dataIndex: "giftcard_amount",
    key: "giftcard_amount",
    width: 140,
    slots: { customRender: "giftcard_amount" },
  },
];
